var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Cookies from 'js-cookie';
import { Storage } from './Storage';
var CookieStorage = (function (_super) {
    __extends(CookieStorage, _super);
    function CookieStorage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CookieStorage.isSupported = function () {
        if (typeof this.isSupportedMark !== 'undefined') {
            return this.isSupportedMark;
        }
        var key = 'life_on_mars';
        Cookies.set(key, 'exists', { expires: 100 });
        var result = Cookies.get(key);
        Cookies.remove(key);
        this.isSupportedMark = !!result;
        return this.isSupportedMark;
    };
    CookieStorage.prototype.getAccessToken = function () {
        return Cookies.get(this.accessTokenName) || '';
    };
    CookieStorage.prototype.getRefreshToken = function () {
        return Cookies.get(this.refreshTokenName) || '';
    };
    CookieStorage.prototype.setAccessToken = function (accessToken) {
        Cookies.set(this.accessTokenName, accessToken, { expires: 100, domain: this.config.domain });
    };
    CookieStorage.prototype.setRefreshToken = function (refreshToken) {
        Cookies.set(this.refreshTokenName, refreshToken, { expires: 100, domain: this.config.domain });
    };
    CookieStorage.prototype.setItem = function (key, value, options) {
        Cookies.set(key, value, __assign({ domain: this.config.domain }, options));
    };
    CookieStorage.prototype.removeItem = function (item, options) {
        Cookies.remove(item, __assign({ domain: this.config.domain }, options));
    };
    CookieStorage.prototype.getItem = function (key) {
        return Cookies.get(key);
    };
    CookieStorage.prototype.removeTokens = function () {
        Cookies.remove(this.accessTokenName);
        Cookies.remove(this.accessTokenName, { domain: this.config.domain });
        Cookies.remove(this.refreshTokenName);
        Cookies.remove(this.refreshTokenName, { domain: this.config.domain });
    };
    return CookieStorage;
}(Storage));
export { CookieStorage };
//# sourceMappingURL=CookieStorage.js.map